import { render, staticRenderFns } from "./AccuracyCourseTable.vue?vue&type=template&id=14006e9e&scoped=true&"
import script from "./AccuracyCourseTable.vue?vue&type=script&lang=js&"
export * from "./AccuracyCourseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14006e9e",
  null
  
)

export default component.exports